import fetch from '@/utils/fetch';

export function save(obj) {
    return fetch({
        url: '/companys',
        method: 'post',
        data: obj
    });
}

export function edit(obj) {
    return fetch({
        url: '/companys/' + obj.id + '/update',
        method: 'post',
        data: obj
    });
}

export function get(id) {
    return fetch({
        url: '/companys/' + id,
        method: 'get'
    });
}

export function listCompanys(params) {
    return fetch({
        url: '/companys',
        method: 'get',
        params
    });
}

export function remove(id) {
    return fetch({
        url: '/companys/' + id + '/remove',
        method: 'post'
    });
}

/*公司初始化列表*/
export function companysList(params) {
    return fetch({
        url: '/companys',
        method: 'get',
        params
    });
}

/*新公司初始化  添加*/
export function companysAdd(obj) {
    return fetch({
        url: '/companys/init',
        method: 'post',
        data: obj
    });
}

//公司配置

export function companyCftSave(obj) {
    return fetch({
        url: '/configure/saveCompany',
        method: 'post',
        data: obj
    });
}

export function companyCftList(params) {
    return fetch({
        url: '/configure/getCompany',
        method: 'get',
        params
    });
}

// 获取公司详细设置（超级管理员）
// /configure/getCompanySystem/{companyId}   GET
//
export function companyCftSystemList(id) {
    return fetch({
        url: '/configure/getCompanySystem/' + id,
        method: 'get',
    });
}

// 设置公司详细设置（超级管理员）
// /configure/saveCompanySystem/{companyId}  POST
// 参数：同/configure/saveCompany'
export function companyCftSysSave(obj) {
    return fetch({
        url: '/configure/saveCompanySystem',
        method: 'post',
        data: obj
    });
}

//获取某个公司下的可用功能和权限
export function companyPermissionGroupList(params) {
    return fetch({
        url: '/companyPermissionGroup/list',
        method: 'get',
        params
    });
}

//保存某个公司下可用功能和权限
export function companyPermissionGroupSave(obj) {
    return fetch({
        url: '/companyPermissionGroup/save',
        method: 'post',
        data: obj
    });
}


//API用户列表
export function apiaccountList(params) {
    return fetch({
        url: '/apiaccount/list',
        method: 'get',
        params
    });
}
//获取单个API用户的信息
export function apiaccountId(params) {
    return fetch({
        url: '/apiaccount/'+params.id,
        method: 'get',
        params
    });
}
//新增或修改一个API用户的信息
export function apiaccountSave(obj) {
    return fetch({
        url: '/apiaccount/save',
        method: 'post',
        data:obj
    });
}
//公司logo配置查询
export function getCompanyWithKey(params) {
    return fetch({
        url: '/configure/getCompanyWithKey',
        method: 'get',
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/company.js